import { optimize } from 'svgo/browser'
import { svgoConfig, postProcessSvg } from './svg-optimizer-config'

/**
 * Optimizes an SVG string for use as an icon (browser version).
 * - Inlines styles and converts to attributes
 * - Removes dimensions (uses viewBox)
 * - Converts colors to currentColor for themability
 * - Replaces stroke-width with placeholder for customization
 */
export function optimizeSvg(svg: string): string {
	try {
		const { data } = optimize(svg, svgoConfig)
		return postProcessSvg(data)
	} catch (e) {
		console.error('SVGO optimization failed:', e)
		return svg // Return original on error
	}
}
